import { GetterTree } from 'vuex';
import RootState from '@/store/RootState';
import LocationState from '@/store/modules/locations/LocationState';

const getters: GetterTree<LocationState, RootState> = {
    activeLocationPanelItem(state): string | null {
        return state.activeLocationPanelItem;
    },
    mobileMenuOpened(state): boolean | null {
        return state.mobileMenuOpened;
    },
};

export default getters;
